<div class="authentication-theme auth-style_1">
  <div class="row">
    <div class="col-12 logo-section">
      <a href="../../index.html" class="logo">
        <img src="../assets/images/logo.png" alt="logo" />
      </a>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-5 col-md-7 col-sm-9 col-11 mx-auto">
      <div class="grid">
        <div class="grid-body">
          <div class="row">
            <div class="col-lg-7 col-md-8 col-sm-9 col-12 mx-auto form-wrapper">
              <form>
                <div class="form-group input-rounded">
                  <input type="text" name="email" [(ngModel)]="user.email" class="form-control" placeholder="Username" />
                </div>
                <div class="form-group input-rounded">
                  <input type="password" name="password" [(ngModel)]="user.password" class="form-control" placeholder="Password" />
                </div>
                <button (click)="login($event)" class="btn btn-primary btn-block"> Login </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
